import { useEffect } from 'react'
import { toast } from 'react-hot-toast'
import type { ReminderType } from '../types/UserDataType'

/** Mirrors loaded reminder changes into the native device's offline scheduler. */
export function useNativeSilaReminders(reminders: ReminderType[], loading: boolean) {
  useEffect(() => {
    if (loading) return
    const bridge = (
      window as unknown as {
        ReactNativeWebView?: { postMessage: (_message: string) => void }
      }
    ).ReactNativeWebView
    if (!bridge) return
    /** Sends a complete snapshot so deletions and completed visits are reconciled. */
    const sync = () =>
      bridge.postMessage(
        JSON.stringify({
          type: 'syncSilaReminders',
          reminders: reminders.map(({ id, title, nextCheck }) => ({
            id,
            title,
            nextCheck,
          })),
        }),
      )
    /** Reports a failed native schedule instead of silently losing reminders. */
    const reportError = () =>
      toast.error(
        'Sıla-i rahim bildirimleri kurulamadı. Telefonun bildirim izinlerini kontrol edin.',
        { id: 'sila-notification-error' },
      )
    window.addEventListener('__hayirhahNativeReady', sync)
    window.addEventListener('__hayirhahSilaReminderError', reportError)
    sync()
    return () => {
      window.removeEventListener('__hayirhahNativeReady', sync)
      window.removeEventListener('__hayirhahSilaReminderError', reportError)
    }
  }, [reminders, loading])
}
